import { css, styled } from 'styled-components';
import * as Ariakit from '@ariakit/react';
import { ReactNode, useEffect } from 'react';

import { AriaMenuItem, NavbarMenuItemContent } from './NavbarMenuItem';
import { IconNames } from '../../../assets';
import { theme } from '../../../styles';
import { ChevronIconOld } from '../../../assets/icons';
import { NavbarMenuSubMenuContext } from './contexts';

type NavbarMenuSubMenuProps = {
  menuName: string;
  menuIcon?: IconNames;
  children: ReactNode;
};
export const NavbarMenuSubMenu = ({ menuName, menuIcon, children }: NavbarMenuSubMenuProps) => {
  const disclosureStore = Ariakit.useDisclosureStore({});
  const disclosureOpen = Ariakit.useStoreState(disclosureStore, 'open');

  const parentMenuStore = Ariakit.useMenuContext();
  const parentMenuOpen = Ariakit.useStoreState(parentMenuStore, 'open');

  useEffect(() => {
    if (!parentMenuOpen) {
      disclosureStore.hide();
    }
  }, [disclosureStore, parentMenuOpen]);

  return (
    <Ariakit.DisclosureProvider store={disclosureStore}>
      <AriaMenuItem $isButton hideOnClick={false} render={<AriaDisclosure $isOpen={disclosureOpen} />}>
        <NavbarMenuItemContent name={menuName} iconName={menuIcon} />
        <ChevronIconOld direction={disclosureOpen ? 'upward' : 'downward'} variant="thin" width={22} color="black90" />
      </AriaMenuItem>
      <AriaDisclosureContent unmountOnHide>
        <NavbarMenuSubMenuContext.Provider value={{ inNavbarMenuSubMenu: true }}>
          <AriaMenugroup autoFocus>{children}</AriaMenugroup>
        </NavbarMenuSubMenuContext.Provider>
      </AriaDisclosureContent>
    </Ariakit.DisclosureProvider>
  );
};

const AriaDisclosureContent = styled(Ariakit.DisclosureContent)`
  max-height: 0;
  overflow-y: hidden;
  transition: max-height 0.2s ease-in-out;
  &[data-enter] {
    max-height: 100%;
  }
`;

const AriaMenugroup = styled(Ariakit.MenuGroup)`
  background-color: ${theme.colors.black05};
`;

const AriaDisclosure = styled(Ariakit.Disclosure)<{ $isOpen: boolean }>`
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      background-color: ${theme.colors.black05};
    `}

  display: flex !important;
  justify-content: space-between !important;
`;
